export class CEP {
  public value: string;

  constructor(value: string) {
    const cleaned = value.replace(/\D/g, '');
    if (cleaned.length !== 8) {
      throw new Error('Invalid CEP format');
    }
    this.value = cleaned;
  }
}
